var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShape3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1337,
    height: 801,
    viewBox: "0 0 1337 801",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1337 0H0V801H1337V0Z",
    fill: "#F8FAFD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M952.1 833.5L1230.9 485L1531 777.2L1525.8 809.4L1449 914.2L951 834.6L952.1 833.5Z",
    fill: "#48C0B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1137.4 700.3C1176.72 700.3 1208.6 675.138 1208.6 644.1C1208.6 613.062 1176.72 587.9 1137.4 587.9C1098.08 587.9 1066.2 613.062 1066.2 644.1C1066.2 675.138 1098.08 700.3 1137.4 700.3Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M1076.6 622.2C1113.38 622.2 1143.2 592.382 1143.2 555.6C1143.2 518.818 1113.38 489 1076.6 489C1039.82 489 1010 518.818 1010 555.6C1010 592.382 1039.82 622.2 1076.6 622.2Z",
    fill: "#FFCE00"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M212.4 764.5C220.353 764.5 226.8 758.053 226.8 750.1C226.8 742.147 220.353 735.7 212.4 735.7C204.447 735.7 198 742.147 198 750.1C198 758.053 204.447 764.5 212.4 764.5Z",
    fill: "#013D32"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M300.2 764.9C308.153 764.9 314.6 758.453 314.6 750.5C314.6 742.547 308.153 736.1 300.2 736.1C292.247 736.1 285.8 742.547 285.8 750.5C285.8 758.453 292.247 764.9 300.2 764.9Z",
    fill: "#013D32"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M300.2 656.9C308.153 656.9 314.6 650.453 314.6 642.5C314.6 634.547 308.153 628.1 300.2 628.1C292.247 628.1 285.8 634.547 285.8 642.5C285.8 650.453 292.247 656.9 300.2 656.9Z",
    fill: "#013D32"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M388 764.9C395.953 764.9 402.4 758.453 402.4 750.5C402.4 742.547 395.953 736.1 388 736.1C380.047 736.1 373.6 742.547 373.6 750.5C373.6 758.453 380.047 764.9 388 764.9Z",
    fill: "#013D32"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M388 656.9C395.953 656.9 402.4 650.453 402.4 642.5C402.4 634.547 395.953 628.1 388 628.1C380.047 628.1 373.6 634.547 373.6 642.5C373.6 650.453 380.047 656.9 388 656.9Z",
    fill: "#013D32"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M388 568.8C395.953 568.8 402.4 562.353 402.4 554.4C402.4 546.447 395.953 540 388 540C380.047 540 373.6 546.447 373.6 554.4C373.6 562.353 380.047 568.8 388 568.8Z",
    fill: "#013D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.4 747.5C220.353 747.5 226.8 741.053 226.8 733.1C226.8 725.147 220.353 718.7 212.4 718.7C204.447 718.7 198 725.147 198 733.1C198 741.053 204.447 747.5 212.4 747.5Z",
    fill: "#00C9A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.2 747.9C308.153 747.9 314.6 741.453 314.6 733.5C314.6 725.547 308.153 719.1 300.2 719.1C292.247 719.1 285.8 725.547 285.8 733.5C285.8 741.453 292.247 747.9 300.2 747.9Z",
    fill: "#00C9A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M300.2 639.9C308.153 639.9 314.6 633.453 314.6 625.5C314.6 617.547 308.153 611.1 300.2 611.1C292.247 611.1 285.8 617.547 285.8 625.5C285.8 633.453 292.247 639.9 300.2 639.9Z",
    fill: "#00C9A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388 747.9C395.953 747.9 402.4 741.453 402.4 733.5C402.4 725.547 395.953 719.1 388 719.1C380.047 719.1 373.6 725.547 373.6 733.5C373.6 741.453 380.047 747.9 388 747.9Z",
    fill: "#00C9A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388 639.9C395.953 639.9 402.4 633.453 402.4 625.5C402.4 617.547 395.953 611.1 388 611.1C380.047 611.1 373.6 617.547 373.6 625.5C373.6 633.453 380.047 639.9 388 639.9Z",
    fill: "#00C9A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388 551.8C395.953 551.8 402.4 545.353 402.4 537.4C402.4 529.447 395.953 523 388 523C380.047 523 373.6 529.447 373.6 537.4C373.6 545.353 380.047 551.8 388 551.8Z",
    fill: "#00C9A7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.4 536.2H373.6V626H402.4V536.2Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.4 645H373.6V734.8H402.4V645Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.7 645H285.9V734.8H314.7V645Z",
    fill: "url(#paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M290.417 97.3667C302.686 97.3667 312.633 87.4199 312.633 75.15C312.633 62.8801 302.686 52.9333 290.417 52.9333C278.147 52.9333 268.2 62.8801 268.2 75.15C268.2 87.4199 278.147 97.3667 290.417 97.3667Z",
    stroke: "#377DFF",
    strokeWidth: 14.3333,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.3 38.6C257.675 38.6 259.6 36.6749 259.6 34.3C259.6 31.9252 257.675 30 255.3 30C252.925 30 251 31.9252 251 34.3C251 36.6749 252.925 38.6 255.3 38.6Z",
    fill: "#26BCB8"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M292.423 56.3734C290.56 49.9234 294.287 43.1867 300.593 41.3234C307.043 39.4601 313.78 43.1867 315.643 49.4934C317.507 55.9434 313.78 62.6801 307.33 64.5434C301.023 66.5501 294.287 62.8234 292.423 56.3734Z",
    fill: "#F4E800"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 388.03,
    y1: 625.998,
    x2: 388.03,
    y2: 536.244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C9A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 388.03,
    y1: 734.765,
    x2: 388.03,
    y2: 645.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C9A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 300.249,
    y1: 734.765,
    x2: 300.249,
    y2: 645.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C9A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1337,
    height: 801,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape3);
export default __webpack_public_path__ + "static/media/shape-3.e28765de32ffcd26a06ddcd89af92bbd.svg";
export { ForwardRef as ReactComponent };